import { WaterAdditionHistoryMessages, TranslationWaterAdditionHistoryMessages } from "../interfaces/waterAdditionHistoryMessages";

const waterAdditionHistoryMessages: TranslationWaterAdditionHistoryMessages = {
  [WaterAdditionHistoryMessages.title]: "Historial de Adiciones de Agua",
  [WaterAdditionHistoryMessages.waterAdditionHistory]: "Historial de Adiciones de Agua",
  [WaterAdditionHistoryMessages.filterTitle]: "Filtrar Historial de Adiciones de Agua",
  [WaterAdditionHistoryMessages.fleetCode]: "Flota",
  [WaterAdditionHistoryMessages.licensePlate]: "Placa",
  [WaterAdditionHistoryMessages.startDate]: "Fecha Inicio",
  [WaterAdditionHistoryMessages.finishDate]: "Fecha Fin",
  [WaterAdditionHistoryMessages.driver]: "Conductor",
  [WaterAdditionHistoryMessages.document]: "Doc.",
  [WaterAdditionHistoryMessages.vehicleState]: "Estado del Vehículo",
  [WaterAdditionHistoryMessages.waterAdded]: "Agua Agregada (L)",
  [WaterAdditionHistoryMessages.moment]: "Momento",
  [WaterAdditionHistoryMessages.address]: "Dirección",
  [WaterAdditionHistoryMessages.preDischarge]: "Pre-Descarga",
  [WaterAdditionHistoryMessages.postDischarge]: "Post-Descarga",
  [WaterAdditionHistoryMessages.noDataFound]: "No se encontraron datos para el período seleccionado"
};

export const messages = waterAdditionHistoryMessages;
